import * as React from 'react';
import styled from 'styled-components';
import { Spinner,SimpleGrid,Center,Box,Button,Text,Input,FormControl,Modal,ModalOverlay,ModalContent,ModalHeader,ModalFooter,ModalBody,ModalCloseButton,useDisclosure,useToast, Image} from '@chakra-ui/react';


type Props = {
    // buttonText: string,
}
export const UsedMintBrowserTabImage: React.FC<Props> = (props) => {
  const imageWrapperStyle: React.CSSProperties = {
    paddingTop: '90px',
    // marginLeft:`30px`,
  };
  return (
    <div id="imagewrapper" style={imageWrapperStyle}>
        <Image
          src='https://nfttopshot-template.onrender.com/template-images/logo-sushi-error.png'
          display={'unset'}
        />
    </div>
  );
};